import { Alert, Box } from "@mui/material";
import { firebaseHelper, useDesignFirm, useTeams } from "ui";
import { sharingV2Doc } from "ui/utils/workspace/sharingV2";
import { projectAudience } from "./accessText";

// Teams sharing: filing an item into a shared project shares it with the
// project's audience, so say so at filing time (spec: "The board will be too").
export const FilingWarning = ({
  project,
  me,
  then,
}: {
  project: Record<string, any> | null | undefined;
  me: string;
  then: string;
}) => {
  const firmId = project?.design_firm_id || undefined;
  const { teams } = useTeams(firmId, firebaseHelper.db, false, true);
  const { firm } = useDesignFirm(firebaseHelper.db, firmId);
  const audience = projectAudience(project, me, teams, firm?.name);
  if (!audience) return null;
  return (
    <Alert severity="info" data-testid="filing-warning" sx={{ mt: 1 }}>
      This project is shared with {audience}. {then}
    </Alert>
  );
};

// The same notice for the bulk pickers on a project page; nothing unless the
// project's team has sharing v2.
export const ProjectFilingNotice = ({
  project,
  me,
  then,
}: {
  project: Record<string, any> | null | undefined;
  me: string;
  then: string;
}) =>
  sharingV2Doc(project) ? (
    <Box sx={{ px: 2, pt: 1 }}>
      <FilingWarning project={project} me={me} then={then} />
    </Box>
  ) : null;
